<template>
  <div data-track="Review Invitations Template" class="invite-template">
    <div class="columns is-flex-tablet">
      <div class="left-section column is-7-widescreen is-7-desktop is-7-tablet is-full-mobile review-left-box left-section-box">
        <p class="review-invite-info-box">Choose your preferred review invite submission type and setup your email template before sending invites to your customers.</p>
        <div class="field has-margin-top-1">

          <div class="control tooltip-submission">
            <a class="tooltip">
              <img src="/static/img/review_images/group-627.png"
                   srcset="/static/img/review_images/group-627@2x.png 2x,
                  /static/img/review_images/group-627@3x.png 3x"
                   class="Group-627">
              <span class="tooltiptext submission-type">
                    <p>
                      <strong>In-mail invites</strong> allow your customers to write and submit reviews right from their email - without ever leaving their inbox.
                      <strong>Important</strong> - In-mail templates may not render on certain browsers, devices and email clients. In such cases we will automatically deliver a modified version of the in-mail template.<br>
                      <strong>Landing page invites</strong> drives customers out of their email to a landing page where they can write and submit their review.<br>
                      <strong>In-mail</strong> and <strong>Landing page invites</strong> do not require your customers to sign-in or register to write and submit reviews.
                    </p>
                  </span>
            </a>
            <label class="dropdown-with-arrow">
              <label class="label is-size-7">Submission Type

              </label>
              <select data-track="Select In-Mail Submission Type" class="input" v-model="mailType" @change="getReviewInvitationTemplate('selected')">
                <option value="LANDINGPAGE">Landing Page Template</option>
                <option value="INMAIL">In-mail Template</option>
              </select>
              <i data-v-cc81503e="" aria-hidden="true" class="fas fa-angle-down"></i>
            </label>
          </div>
        </div>

        <div class="left-email-box column" v-if="userType">
          <h6 class="is-size-10 has-text-weight-bold email-customisation-font">Email customisation</h6>
          <div class="field has-margin-top-1">
            <label class="label label-header">Email Subject</label>
            <div class="control">
              <input
                :class="[{'disable-field': !userType}, 'input']"
                type="text"
                placeholder="Text input"
                v-model="subject"
                ref="subject"
                @keyup="handleFieldChange"
                @input="isTyping = true"
                @click="currentCursor = 'subject'"
              >
            </div>
          </div>
          <div class="field">
            <label class="label label-header">Body</label>
            <div class="control">
              <textarea
                class="invite-body-textarea"
                :class="[{'disable-field': !userType},'textarea has-fixed-size']"
                placeholder="Textarea"
                v-model="body"
                ref="body"
                @keyup="handleFieldChange()"
                @input="isTyping = true"
                @click="currentCursor = 'body'"
              ></textarea>
            </div>
          </div>
          <div class="field margin-bottom-7">
            <label class="label label-header">Tags</label>
            <div class="control">
              <ul class="tags">
                <li v-for="tag of tags" v-bind:key="tag" class="tag" :class="[{'add-tag': userType}]" @click="handleTag(tag)">{{ tag }}</li>
              </ul>
            </div>
          </div>
          <!-- Section to upload template review logo -->
          <template v-if="logoImageError">
                <span class="help is-clipped is-danger font-size-11">
                  {{ logoImageError }}
                </span>
          </template>
          <h1 style="display:none">{{ JSON.stringify(newFile) }}</h1>
          <add-logo group="reviewInviteEmailTemplate" :logoPath="(image === '' || !('logo' in image))?'':image.logo.path">
            <template slot="label">
              <span class="label label-header totals-block is-inline-block">Logo</span>
            </template>
          </add-logo>
          <!--End Logo Upload Section-->

          <!--Section to upload review invite template header-->
          <template v-if="headerImageError">
                <span class="help is-clipped is-danger font-size-11">
                  {{ headerImageError }}
                </span>
          </template>
          <div class="field tooltip-header">
            <label class="label label-header totals-block">Header Image
              <a class="tooltip">
                <img src="/static/img/review_images/group-627.png"
                     srcset="/static/img/review_images/group-627@2x.png 2x,
                    /static/img/review_images/group-627@3x.png 3x"
                     class="Group-627">
                <span class="tooltiptext">
                  <p>
                    Upload a PNG or JPEG file.
                    The minimum or expected size is 602 x 146 px.
                    Max file size is 10 MB.
                  </p>
                </span>
              </a>
              <p style="font-weight: normal;">Upload your own header image or select an image from our range of existing images.</p>
            </label>

            <div class="control">
              <template>
                <div class="photo-row is-clearfix margin-top-10">
                  <img v-if="(image == '') || !('header' in image)"
                       src="/static/img/mailers/users/mailer-header-image-default.png"
                       class="photo-row-img photo-row-thumbnail is-pulled-left"
                  />
                  <img v-else :src="image.header.path" class="photo-row-img photo-row-thumbnail is-pulled-left"/>
                  <a class="photo-upload-link"
                     :class="[{'disable-field': !userType}]"
                     href="#"
                     @click.prevent="openImageLibModal('headerImage')"
                  >
                    <u>Add Header Image</u>
                  </a>
                  <a v-if="('header' in image)"
                     @click.prevent="removeFiles(image.header.type)"
                     class="photo-row-remove"
                     :class="[{'disable-field': !userType}]"
                     href="#"
                  ><u>Remove</u>
                  </a>

                </div>
              </template>
            </div>
          </div>
          <!--End Header Upload Section-->

          <!--Allow to add photo option-->
          <div class="field" v-if="mailType === 'LANDINGPAGE' && userType">
            <label class="label label-header">Upload photos <br>
              <span class="allow-photo">Allow users to upload photos when they leave a review.</span>
            </label>
            <div class="control">
              <ul class="tags allow-photo-ul">
                <label class="radio allow-photo-radio">
                  <input :disabled="!userType" type="radio" value="yes" @change="changeUploadOption" v-model="allowToAddPhotos"
                  >
                  Yes
                </label>
                <label class="radio allow-photo-radio">
                  <input :disabled="!userType" type="radio" value="no" @change="changeUploadOption" v-model="allowToAddPhotos"
                  >
                  No
                </label>
              </ul>
            </div>
          </div>
        </div>
        <template v-else>

          <!---Email header customization div for free biz---->
          <div class="left-email-box column">
            <h6 class="is-size-10 has-text-weight-bold email-customisation-font">Email customisation</h6>

            <!--Section to upload review invite template header-->
            <template v-if="headerImageError">
                <span class="help is-clipped is-danger font-size-11">
                  {{ headerImageError }}
                </span>
            </template>
            <div class="field tooltip-header">

              <div class="control">
                <template>
                  <div class="photo-row is-clearfix margin-top-10">
                    <img v-if="(image == '') || !('header' in image)"
                         src="/static/img/mailers/users/mailer-header-image-default.png"
                         class="photo-row-img photo-row-thumbnail is-pulled-left"
                    />
                    <img v-else :src="image.header.path" class="photo-row-img photo-row-thumbnail is-pulled-left"/>
                    <a class="photo-upload-link"
                       href="#"
                       @click.prevent="openImageLibModal('headerImage')"
                    >
                      <u>Add Header Image</u>
                    </a>
                    <a v-if="('header' in image)"
                       @click.prevent="removeFiles(image.header.type)"
                       class="photo-row-remove"
                       href="#"
                    ><u>Remove</u>
                    </a>

                  </div>
                </template>
              </div>
            </div>
            <!--End Header Upload Section-->
          </div>

          <!---New div for free biz---->
          <div class="left-email-box column">
            <h6 class="is-size-10 has-text-weight-bold email-customisation-font">Email customisation</h6>
            <i class="fas fa-lock free-biz-fa-lock"></i>
            <hr class="email-horizontal-row">
            <p class="free-biz-offer-info">
              <a href="#" @click.prevent="renewOrUpgrade">Upgrade</a>
              your Package and instantly gain access to customise your email review invitation.
              Create a custom message and add your brand's imagery to increase conversions.
            </p>
          </div>
        </template>

        <!-- Send Test Email Begin -->
        <div class="columns has-margin-top-1">
          <div class="column is-three-quarters">
            <input
              :class="'input'"
              type="text"
              placeholder="Email address"
              v-model="testEmail"
            >

            <button
              :disabled="!isValidEmail"
              :class="[{ 'is-loading': isSendingTest, 'preview-button-color': !isSendingTest && !isValidEmail }, 'button is-button-blue-outline is-uppercase']"
              @click="handleSendTestEmail"
            >
              SEND TEST
            </button>
          </div>
          <div class="column save-button">
            <button
              :disabled="!isFormChanged"
              @click="saveContent"
              :class="[{ 'is-loading': isSaving }, 'button is-button-blue is-uppercase']"
              data-track="save review invite email template"
            >
              Save Changes
            </button>
          </div>
        </div>
        <p class="has-text-danger email-validation" v-if="(!isValidEmail && testEmail) || errors.testEmail.email">
          {{ errors.testEmail ? errors.testEmail.email[0] : 'Please provide a valid email address' }}</p>
        <!-- Send Test Email End -->
      </div>
      <div class="right-section column preview has-spinner">
        <h6 class="is-size-7  title-business preview-header">Preview
          <div class="preview-mobile-desktop-icon">
            <div class="preview-toggle-icons">
              <span class="desktop-icon"
                    v-on="isActive ? { click: () => responsive('desktop') } : {click: ($event) => $event.preventDefault() }"
                    :class="{ 'has-text-weight-bold active': !isActive }">
                <img class="ds1" src="/static/img/desktop-icon-white.png">
                <img class="ds2" src="/static/img/desktop-icon-grey1.png">
              </span>
              <span class="mob-icon"
                    v-on="!isActive ? { click: () => responsive('mobile') } : {click: ($event) => $event.preventDefault() }"
                    :class="{ 'has-text-weight-bold active': isActive }">
                <img class="mb1" src="/static/img/mobile-icon-white.png">
                <img class="mb2" src="/static/img/mobile-icon-grey.png">
              </span>
            </div>
          </div>
        </h6>
        <div v-if="isPreviewing">
          <p class="has-text-centered">
            <img class="has-spinner__spinner" src="/static/img/spinner.svg" alt="fetching Review Breakdown..."/>
          </p>
        </div>
        <iframe :srcdoc="htmlPreview" :width="iframeWidth" height="580" style="margin-top: 20px; transform: scale(0.9); " v-if="!isPreviewing"></iframe>
      </div>
    </div>

    <ImageLibraryModal
      :show=toggleModal
      :key="reRenderIndex"
      :chosenTab="tabName"
      @closeModal="toggleModal=!toggleModal"
      @imageSelected="imageSelected"
    ></ImageLibraryModal>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc, no-useless-escape */
import axios from 'axios'
import {AddLogo, ImageLibraryModal} from '@/components'

export default {
  name: 'ReviewInviteTemplate',
  components: {
    ImageLibraryModal,
    AddLogo
  },
  data () {
    return {
      tags: [],
      body: '',
      subject: '',
      errors: {
        testEmail: ''
      },
      userInfo: JSON.parse(localStorage.getItem('billingDetails')),
      isActive: false,
      isSaving: false,
      testEmail: '',
      isPreviewing: false,
      leavingPage: false,
      isSendingTest: false,
      isFormChanged: false,
      htmlPreview: '',
      iframeWidth: '600px',
      currentCursor: 'body',
      image: {},
      newFile: [],
      logoImageError: '',
      headerImageError: '',
      logoToolTipVisible: false,
      headerToolTipVisible: false,
      allowToAddPhotos: 'no',
      businessSlug: localStorage.getItem('org_slug'),
      mailType: 'INMAIL', /** ['INMAIL', 'LANDINGPAGE'] */
      setAsSelected: false,
      isTyping: false,
      toggleModal: false,
      tabName: '',
      reRenderIndex: 0
    }
  },
  metaInfo: {
    title: 'Business Portal | Hellopeter - Review Invites Template'
  },
  created () {
    window.events.$on('add-logo', (data) => {
      if (data.group === 'reviewInviteEmailTemplate') {
        if (data.action === 'add') {
          this.openImageLibModal('logoImage')
        } else if (data.action === 'remove') {
          this.removeFiles(this.image.logo.type)
        }
      }
    })

    if (this.leavingPage === true || this.isFormChanged === false) {
      this.leavingPage = false
    }
    if (localStorage.hasOwnProperty('mailType')) {
      this.mailType = JSON.parse(localStorage.getItem('mailType'))
    }
    // Event bus for modal's response
    window.events.$on('navigateTowardsRoute', this.handleNavigation)
    this.isPreviewing = true
    // Getting the template content for preview
    this.updateBusinessType()
      .then((response) => {
        this.userInfo.subscription.name = response.subscription.name
        this.getReviewInvitationTemplate('get')
      })
    // Adding the unload event, when user want to leave unsaved changes
    window.addEventListener('beforeunload', (event) => {
      // If user changed the form and is Enterprise/Pro user
      if (this.isFormChanged && this.userType) {
        event.preventDefault()
        event.returnValue = 'You have unsaved changes. If you close this tab, your changes will be lost.'
      }
    })
  },
  destroyed () {
    window.events.$off('add-logo')
  },
  computed: {
    /**
     * Check the user type whether it is of Enterprise/Pro
     * @return {boolean}
     */
    userType () {
      // If user having Enterprise/Pro business
      return this.userInfo.subscription.name !== 'Free'
    },
    /**
     * Checking entered email is valid and has no validation error
     * @return {boolean}
     */
    isValidEmail () {
      let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.errors.testEmail = ''
      return regex.test(this.testEmail)
    }
  },
  watch: {
    subject: _.debounce(function () {
      this.isTyping = false
    }, 2000),
    body: _.debounce(function () {
      this.isTyping = false
    }, 2000),
    isTyping: function (value) {
      if (!value) {
        this.getReviewInvitationTemplate(this.subject, this.body, this.image)
      }
    }
  },
  methods: {
    /**
     * Change option to add photos
     */
    changeUploadOption  (e) {
      this.allowToAddPhotos = e.target.value
      this.handleFieldChange()
    },
    /**
     * Remove selected files after upload
     */
    removeFiles (type) {
      if (type === 'logo') {
        this.$delete(this.image, 'logo')
      }
      if (type === 'header') {
        this.$delete(this.image, 'header')
      }
      this.isTyping = false
      this.handleFieldChange()
      this.getReviewInvitationTemplate('preview')
    },
    /**
     * Update business in local storage, in case of business switch
     * @return {Promise}
     */
    updateBusinessType () {
      return new Promise((resolve) => {
        axios.get(`/${this.businessSlug}/billing-details`)
          .then(({data}) => {
            localStorage.setItem('billingDetails', JSON.stringify(data))
            resolve(data)
          })
      })
    },
    /**
     * Get name of current selected Org Subscription
     * @return {boolean}
     */
    isFreeSubscription () {
      if (window.localStorage.getItem('billingDetails')) {
        return (JSON.parse(window.localStorage.getItem('billingDetails')).subscription.name).toLowerCase() === 'free'
      }
      return false
    },
    /**
     * Get the invitation template content for preview
     * @return {void}
     */
    getReviewInvitationTemplate (mode = 'get') {
      let data = {
        type: this.mailType
      }

      if (mode === 'get') {
        data = Object.assign(data, {body: '', subject: '', mode: 'get'})
      } else if (mode === 'selected') {
        data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
      } else {
        data = Object.assign(data, {body: this.body, subject: this.subject, files: this.image, allowToAddPhotos: this.allowToAddPhotos, mode: 'preview'})
      }

      axios.post(`/${this.businessSlug}/review/get-invite-template`, data)
        .then((response) => {
          localStorage.setItem('mailType', JSON.stringify(this.mailType))
          this.body = response.data.body
          this.htmlPreview = response.data.view
          this.subject = response.data.subject
          this.tags = response.data.tags
          this.allowToAddPhotos = response.data.allowUserToUpload
          this.image = response.data.attachment
          this.isPreviewing = false
          if (response.data.type !== undefined) {
            this.mailType = response.data.type
          }
        })
        .catch(() => {
          flash('You are not authorized to view this resource.', 'is-danger')
        })
    },
    /**
     * Toggle between Desktop and mobile preview
     * @return {void}
     */
    responsive (type) {
      this.isActive = !this.isActive
      this.iframeWidth = type === 'desktop' ? '600px' : '320px'
    },
    /**
     * When user change any text in fields
     * @return {void}
     */
    handleFieldChange () {
      this.isFormChanged = true
    },
    /**
     * Handling redirection when user want to leave the page
     * @param routeTowards Route towards request is navigating
     * @return {void}
     */
    handleNavigation (routeTowards) {
      this.leavingPage = true
      if (this.isFormChanged) {
        this.$router.push(routeTowards)
        this.isFormChanged = false
      }
    },
    /**
     * Save the subject/body to DB
     * @return {void}
     */
    saveContent () {
      this.isSaving = true
      axios.post(`/${this.businessSlug}/review/invite-template`, {
        body: this.body,
        subject: this.subject,
        type: this.mailType,
        allowToAddPhotos: this.allowToAddPhotos,
        files: this.image,
        setAsSelected: this.setAsSelected
      })
        .then((response) => {
          flash(response.data.message, 'is-success')
          this.isSaving = this.isFormChanged = false
          this.allowToAddPhotos = 'no'
          this.getReviewInvitationTemplate('get')
        })
        .catch((error) => {
          this.isSaving = this.isFormChanged = false
          flash(error.response.data.message, 'is-danger')
        })
    },
    /**
     * Replace the selected tag with selected string or at end of textarea string
     * @param {string} tag Selected tag
     * @return {void}
     */
    handleTag (tag) {
      // If user is Enterprise/Pro business user
      if (this.userType) {
        this.handleFieldChange()
        // Getting the reference where to append tag [subject|body]
        let tArea = this.$refs[this.currentCursor]
        let startPos = tArea.selectionStart
        let endPos = tArea.selectionEnd
        let tmpStr = tArea.value
        // insert the chosen tag to selected text or at very end of the textarea string
        this[this.currentCursor] = tmpStr.substring(0, startPos) + ` ${tag} ` + tmpStr.substring(endPos, tmpStr.length)
      }
    },
    /**
     * Send test mail to given email
     * @return {void}
     */
    handleSendTestEmail () {
      this.isSendingTest = true
      axios.post(`/${this.businessSlug}/review/send-test-email`, {
        email: this.testEmail
      })
        .then(({data: {message: msg}}) => {
          this.isSendingTest = false
          this.errors.testEmail = this.testEmail = ''
          flash(msg, 'is-success')
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Successfully sent Review Invitations test email',
              'displayedMessage': msg
            }
          })
          window.scrollTo(0, 0)
        })
        .catch(({response}) => {
          this.isSendingTest = false
          /**
           * If unprocessable Entity (Validation Error)
           */
          if (response.status === 422) {
            this.errors.testEmail = response.data
          } else {
            flash(response.data.message, 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed sending Review Invitations test email',
                'displayedMessage': response.data.message
              }
            })
          }
        })
    },
    imageSelected (img) {
      if (img.image_type === 'HEADER') {
        this.image.header =
          {
            'originalName': img.data.originalName,
            'type': img.data.type,
            'path': img.data.imageForlderUrl + img.data.fileName
          }
      } else {
        this.image.logo =
          {
            'originalName': img.data.originalName,
            'type': img.data.type,
            'path': img.data.imageForlderUrl + img.data.fileName
          }
      }
      this.getReviewInvitationTemplate('preview')
      this.handleFieldChange()
      this.toggleModal = !this.toggleModal
    },
    openImageLibModal (tabName) {
      ++this.reRenderIndex
      this.tabName = tabName
      this.toggleModal = !this.toggleModal
    },
    /**
     *  Redirect to renew or upgrade page
     *  @returns {void}
     */
    renewOrUpgrade () {
      this.$router.push('/billing/edit-plan/g1/monthly')
    }
  },
  /**
   * Event before navigating to desired route
   * @param {object} to Route where user want to navigate
   * @param {object} from Route where is coming from navigation
   * @param {function} next Navigating towards the intended route if true
   * @return {void}
   */
  beforeRouteLeave (to, from, next) {
    // If user changed the form and is Enterprise/Pro user
    if (this.isFormChanged && !this.leavingPage && this.userType) {
      this.modal_props = {
        title: 'Are you sure?',
        body: 'You have unsaved changes on this page. If you navigate away, your changes will be lost. ',
        btn_action_title: 'STAY ON THIS PAGE',
        secondary_btn_title: 'LEAVE PAGE',
        to_path: to.path,
        show_btns: true,
        task: 'deleteInvite'
      }
      // Fire off confirmation modal
      modal(this.modal_props)
    } else {
      next()
    }
  }
}
</script>
<style>
.invite-template {
  margin-top: 28px;
}

.left-section {
  padding-left: 0;
}

.add-tag {
  cursor: pointer;
}

.tags li {
  padding: 5px;
  background-color: rgba(138, 140, 145, 0.1);
  color: #868282;
}

.disable-field {
  pointer-events: none;
}

.right-section {
  max-width: 100%;
}

.left-email-box {
  border: 1px solid #CCCCCC;
  max-width: 100%;
  margin-top: 15px;
}

iframe {
  max-width: 100%;
  margin: 0px auto;
  display: block;
  padding: 0 25px;
}

.responsive-action {
  text-align: center;
  margin-bottom: 10px;
}

.responsive-action span {
  cursor: pointer;
}

.has-margin-top-1 {
  margin-top: 3px;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}
</style>
<style scoped>
.has-spinner__spinner {
  max-width: 60px;
  width: 100%;
}

.label-header {
  font-size: 12px;
  font-weight: 600;
  color: #58595b;
}

.preview-button-color, .preview-button-color:hover {
  width: 30%;
  float: left;
  border: solid 1px #30aae1 !important;
  background-color: #ffffff;
}

.disable-field {
  color: #8a8c91 !important;
}

.input {
  color: #4a4a4a;
}

.invite-template .is-three-quarters, .invite-template .is-three-quarters + .column {
  padding-left: 0px;
}

.invite-template .is-three-quarters .input {
  height: 40px;
  width: 70%;
  float: left;
}

.has-text-danger {
  font-size: 0.9em;
}

.dropdown-with-arrow i {
  position: absolute;
  font-size: 1.4rem;
  color: transparent;
  border: 1px solid #95979b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.5em;
  pointer-events: none;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.5em;
  margin-top: -0.375em;
  right: 1.125em;
  top: 70%;
}

.dropdown-with-arrow i:before {
  border: 0px;
}

input:focus, textarea:focus, select:focus {
  border-color: #b5b5b5;
}

.photo-row {
  line-height: 33px;
}

.photo-row-img {
  vertical-align: middle;
  margin-right: 10px
}

.photo-row-thumbnail {
  width: 40px;
  height: 40px;
  border: solid 1px #dbdbdb;
  background-color: #FFFFFF;
  border-radius: 50%;
}

.photo-row-remove {
  color: #30aae1;
  margin-top: 5px;
  margin-left: 10px;
  width: 45px;
  height: 17px;
  font-size: 12px;
}

.photo-upload-link {
  font-size: 12px;
  color: #30aae1;
}

.photo-name {
  font-size: 11px;
  color: #58595b;
}

.allow-photo {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}

.allow-photo-radio {
  color: #707070;
  font-size: 12px;
  padding: 7px;
}

.tooltip {
  position: absolute;
  left: 115px
}

.tooltip-submission a.tooltip {
  display: inline-block;
  position: absolute;
  left: 110px;
}

.tooltip-logo label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 40px;
}

.tooltip-header label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 90px;
}

.tooltip .tooltiptext {
  visibility: hidden;
  background-color: #f3f3f4;
  color: #fff;
  border-radius: 0px;
  min-height: 80px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  top: -37px;
  left: 110px;
  margin-left: -66px;
  opacity: 0;
  transition: opacity 0.3s;
  padding-right: 50px;
}

.tooltip .tooltiptext p {
  width: 180px;
  font-size: 10px;
  font-weight: normal;
  color: #707070;
  padding: 10px 20px;
  text-align: justify;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 30%;
  left: -1px;
  margin-left: -19px;
  border-width: 10px;
  border-style: solid;
  border-bottom: 10px solid #f3f3f4;
  transform: rotate(270deg);
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.tooltiptext.submission-type {
  width: 350px !important;
  height: 232px !important;
  background-color: #f3f3f4;
}

.submission-type.tooltiptext p {;
  width: 308px;
  height: 165px;
  font-weight: normal;
  line-height: 1.55;
  font-size: 11px;
  color: #707070;
}

.right-section.column.preview {
  background-image: url("/static/img/review_images/mask-group-34.png");
  padding: 0;
  height: 689px;
  background-size: cover;
}

.review-left-box {
  padding-right: 25px;
}

.preview-header {
  background-color: #f3f3f4;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 27px;
  width: 100%;
}

.save-button {
  padding-right: 0px;
}

.save-button button {
  width: 100%;
  padding-right: 8px;
}

.tooltip-submission {
  position: relative;
}

.tooltip-logo {
  position: relative;
}

.tooltip-header {
  position: relative;
}

.email-validation {
  margin-top: -17px;
}

.free-biz-fa-lock {
  float: right;
  margin-top: -17px;
  margin-right: 12px;
  color: #cbcbd2;
}

.review-invite-info-box {
  margin-top: -15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}

.email-horizontal-row {
  margin-left: -13px;
  margin-right: -13px;
  margin-top: 9px;
}

.free-biz-offer-info {
  text-align: center;
  margin-bottom: 27px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}

.free-biz-offer-info a {
  text-decoration: underline;
  color: #30aae1;
}

.free-biz-offer-info a:hover {
  color: #30aae1;
}

.input {
  height: 3.25em !important;
  font-size: 12px;
  color: #707070;
}

.invite-body-textarea {
  height: 3.25em !important;
  font-size: 12px !important;
  color: #707070;
}

.email-customisation-font {
  font-size: 14px;
}

.left-section-box {
  width: 47%;
}

@media screen and (max-width: 767px) {
  .left-section-box {
    width: 100% !important;
  }

  .right-section.column.preview {
    width: 100% !important;
  }
}
</style>
<style scoped>
.desktop-icon {
  width: 45px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
}

span.desktop-icon.active .ds1 {
  display: block;
}

span.desktop-icon.active .ds2 {
  display: none;
}

span.desktop-icon .ds2 {
  display: block;
}

span.desktop-icon .ds1 {
  display: none;
}

.mob-icon {
  width: 45px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 9px;
}

.mob-icon.active .mb1 {
  display: block;
}

.mob-icon.active .mb2 {
  display: none;
}

.mob-icon .mb1 {
  display: none;
}

span.mob-icon.active, span.desktop-icon.active {
  background: #909ea9;
}

span.desktop-icon, span.mob-icon {
  background: #fff;
}

.preview-mobile-desktop-icon {
  display: flex;
  float: right;
  margin-right: 23px;
  margin-top: -6px;
  height: 36px;
}

.preview-mobile-desktop-icon .preview-toggle-icons {
  display: inline-flex;
  border: 2px solid #d3d3d3;
  border-radius: 2px;
}

.allow-photo-ul {
  margin-left: -7px;
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewInviteTemplate.vue